import styled from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";

const Title = styled.h4`
	margin-bottom: 20px;
	font-size: var(--derault-size);
	font-weight: normal;
	color: var(--emp-color);
`;

const CouponList = styled.ul`
	padding: 20px 30px;
	border: 1px solid var(--line-color);
	+ h4 {
		margin-top: 40px;
	}
`;

const CouponItem = styled.li`
	font-size: var(--default-size);
	+ li {
		margin-top: 10px;
	}
	> div {
		line-height: 1;
	}
	label {
		display: flex;
		align-items: center;
		input {
			flex: 0 0 auto;
		}
		> span {
			em {
				line-height: 1.6;
				&::after {
					display: inline-block;
					width: 1px;
					height: 12px;
					margin: 0 10px;
					background-color: var(--line-color);
					content: "";
				}
			}
		}
	}
`;

const DownloadLink = styled.a`
	position: relative;
	display: inline-block;
	width: fit-content;
	line-height: 1;
	margin-left: 10px;
	&::before {
		position: absolute;
		bottom: -2px;
		display: inline-block;
		width: 100%;
		height: 1px;
		background-color: var(--default-color);
		content: "";
	}
	&::after {
		position: absolute;
		top: 3px;
		right: -22px;
		display: inline-block;
		width: 15px;
		height: 14px;
		background: url(${SpriteImage}) no-repeat;
		background-position: -145px 0;
		content: "";
	}
`;

const LinkText = styled.a`
	line-height: 1;
	color: var(--blue-color);
	text-decoration: underline;
`;

const TotalPrice = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 40px;
	text-align: center;
	font-size: var(--medium-size);
	color: var(--emp-color);
	> span {
		margin-left: 10px;
		font-size: var(--default-size);
		color: var(--red-color);
		em {
			font-size: 22px;
		}
	}
`;

const SubmitButtonBlock = styled.div`
	display: flex;
	justify-content: center;
	margin: 40px auto 0;
`;

const NoteBoxWrap = styled.div`
	margin-top: 40px;
`;

const BulletList = styled.ul`
	margin-top: 10px;
	li + li {
		margin-top: 8px;
	}
	li {
		> ul {
			margin-top: 10px;
		}
	}
`;

export {
	BulletList,
	CouponItem,
	CouponList,
	DownloadLink,
	LinkText,
	NoteBoxWrap,
	SpriteImage,
	SubmitButtonBlock,
	Title,
	TotalPrice,
};
